module.exports = __webpack_public_path__ + "static/media/egr-system-monitor.8bbac904.svg";